var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ph:arrow-left-bold"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.6094 15.5001C27.6094 15.8855 27.4563 16.2551 27.1838 16.5276C26.9113 16.8001 26.5417 16.9532 26.1563 16.9532H8.35552L14.5943 23.1907C14.8673 23.4637 15.0206 23.834 15.0206 24.22C15.0206 24.6061 14.8673 24.9763 14.5943 25.2493C14.3213 25.5223 13.951 25.6757 13.565 25.6757C13.1789 25.6757 12.8087 25.5223 12.5357 25.2493L3.81692 16.5306C3.68145 16.3956 3.57396 16.2352 3.50062 16.0585C3.42728 15.8819 3.38953 15.6925 3.38953 15.5013C3.38953 15.31 3.42728 15.1206 3.50062 14.944C3.57396 14.7674 3.68145 14.607 3.81692 14.472L12.5357 5.75322C12.6708 5.61805 12.8313 5.51083 13.0079 5.43768C13.1845 5.36452 13.3738 5.32687 13.565 5.32687C13.7561 5.32687 13.9454 5.36452 14.122 5.43768C14.2986 5.51083 14.4591 5.61805 14.5943 5.75322C14.7294 5.88839 14.8367 6.04886 14.9098 6.22547C14.983 6.40207 15.0206 6.59136 15.0206 6.78252C15.0206 6.97368 14.983 7.16296 14.9098 7.33957C14.8367 7.51618 14.7294 7.67665 14.5943 7.81182L8.35552 14.0469H26.1563C26.5417 14.0469 26.9113 14.2 27.1838 14.4725C27.4563 14.7451 27.6094 15.1147 27.6094 15.5001Z",
    fill: "url(#paint0_linear_1_314)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_314",
    x1: 15.5879,
    y1: 6.8038,
    x2: 15.2832,
    y2: 43.7351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#886032"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowL);
export default __webpack_public_path__ + "static/media/arrowL.0c0aa88ee15d1e2556277bcc429bb9fd.svg";
export { ForwardRef as ReactComponent };